import React, { useEffect, useState } from 'react';
import { Link, useOutletContext } from 'react-router-dom';
import styled from 'styled-components';
import DropdownSelect from '../../../components/DropdownSelect';
import ConfirmModal from '../../../components/modal/ConfirmModal';
import HotelController, {
  RoomListCostType,
  RoomListType,
} from '../../../controller/HotelController';
import { CurrentStoreContext } from '../../../controller/StoreController';
import { useToast } from '../../../controller/ToastController';
import HotelRoomSetting from './HotelRoomSetting';

const hourList = Array.from({ length: 49 }, (_, i) => {
  const hour = Math.floor(i / 2);
  const minute = i % 2 === 0 ? '00' : '30';
  return {
    key: i,
    value: i / 2,
    name: `${hour}시간 ${minute}분`,
    label: `${hour}시간 ${minute}분`,
  };
});
hourList.splice(0, 1);

const dayList = [
  {
    name: '월',
    value: 1,
  },
  {
    name: '화',
    value: 2,
  },
  {
    name: '수',
    value: 3,
  },
  {
    name: '목',
    value: 4,
  },
  {
    name: '금',
    value: 5,
  },
  {
    name: '토',
    value: 6,
  },
  {
    name: '일',
    value: 0,
  },
  {
    name: '공휴일',
    value: 7,
  },
];

const dayGroupList = [
  {
    name: '평일',
    value: 0,
  },
  {
    name: '휴일',
    value: 1,
  },
  {
    name: '전체',
    value: 2,
  },
];

const checkGroupMap = [
  [1, 2, 3, 4, 5],
  [0, 6, 7],
  [0, 1, 2, 3, 4, 5, 6, 7],
];

const extendTypeList = [
  {
    name: '퇴실',
    value: 0,
  },
  {
    name: '대실',
    value: 1,
  },
  {
    name: '숙박',
    value: 2,
  },
];

const exposureTypeList = [
  {
    name: '상시',
    value: 0,
  },
  {
    name: '알림',
    value: 1,
  },
];

const HotelRoomSale = () => {
  const showToast = useToast();
  const { currentStore } = useOutletContext<CurrentStoreContext>();
  const [hourSelectDefalut, setHourSelectDefalut] = useState<any>({
    key: -1,
    value: '0',
    name: `연장시간을 선택해주세요`,
    label: `연장시간을 선택해주세요`,
  });
  const [roomList, setRoomList] = useState<RoomListType[]>([]);
  const [prdName, setPrdName] = useState<string>('');
  const [productId, setProductId] = useState<number>();
  const [hour, setHour] = useState<any>();
  const [prdBasePrice, setPrdBasePrice] = useState<number | any>();
  const [prdOrgPrice, setPrdOrgPrice] = useState<number | any>();
  const [areaGradeIdList, setAreaGradeIdList] = useState<number[]>([]);
  const [addRoom, setAddRoom] = useState<boolean>(false);
  const [editRoom, setEditRoom] = useState<boolean>(false);
  const [selectedAreaGradeId, setSelectedAreaGradeId] = useState<number | null>(null);
  const [visibleConfirm, setVisibleConfirm] = useState<boolean>(false);

  const [applyDay, setApplyDay] = useState<number[]>([]);
  const [extendType, setExtendType] = useState<number[]>([]);

  // 상시 여부
  const [exposureType, setExposureType] = useState<number[]>([]);

  const onChangePrdName = (e: any) => {
    setPrdName(e.target.value);
  };
  const onChangePrdBasePrice = (e: any) => {
    setPrdBasePrice(e.target.value);
  };
  const onChangePrdOrgPrice = (e: any) => {
    setPrdOrgPrice(e.target.value);
  };
  const handleCheckboxChange = (e: any, index: number) => {
    const isChecked = e.target.checked;
    const checkedGrade = roomList[index].area_grade_id;

    setAreaGradeIdList((prevState) => {
      if (isChecked) {
        return [...prevState, checkedGrade];
      } else {
        return prevState.filter((id) => id !== checkedGrade);
      }
    });
  };

  const onChangeHour = (e: any) => {
    setHour(e);
  };

  const getCheckGroupChecked = (value: number) => {
    const targetValues = checkGroupMap[value];
    return targetValues.every((v) => applyDay.includes(v));
  };

  const handleCheckboxDayGroupChange = (e: any, value: number) => {
    const targetValues = checkGroupMap[value];

    setApplyDay((prevState) => {
      if (getCheckGroupChecked(value)) {
        return prevState.filter((v) => !targetValues.includes(v));
      } else {
        const newValues = new Set(prevState);
        targetValues.forEach((v) => newValues.add(v));
        return Array.from(newValues);
      }
    });
  };

  // 체크박스 아이템 변경
  const handleCheckboxStatusChange = (type: string, e: any, value: number) => {
    const isChecked = e.target.checked;
    if (type === 'applyDay') {
      setApplyDay((prevState) => {
        if (isChecked) {
          return [...prevState, value];
        } else {
          return prevState.filter((item) => item !== value);
        }
      });
    } else if (type === 'extendType') {
      setExtendType((prevState) => {
        if (isChecked) {
          return [...prevState, value];
        } else {
          return prevState.filter((item) => item !== value);
        }
      });
    } else if (type === 'exposureType') {
      setExposureType((prevState) => {
        if (isChecked) {
          return [...prevState, value];
        } else {
          return prevState.filter((item) => item !== value);
        }
      });
    }
  };

  // 체크박스 체크 여부
  const checkBoxChecked = (type: string, value: number) => {
    if (type === 'applyDay') {
      return applyDay.filter((item) => item === value).length > 0;
    } else if (type === 'extendType') {
      return extendType.filter((item) => item === value).length > 0;
    } else if (type === 'exposureType') {
      return exposureType.filter((item) => item === value).length > 0;
    } else return false;
  };

  const editRoomButton = (room: RoomListCostType) => {
    const selectedHour = hourList.find(
      (hourItem) => hourItem.value === Number(room.hour_extension),
    );

    console.log('room', room);

    setAddRoom(false);
    setEditRoom(true);
    setPrdName(room.name);
    setPrdBasePrice(room.base_price);
    setPrdOrgPrice(room.org_price);
    if (selectedHour) {
      setHourSelectDefalut(selectedHour);
      setHour(selectedHour);
    }
    setProductId(room.product_id);
    setApplyDay(room.apply_day);
    setExtendType(room.extend_type);
    setExposureType(room.exposure_type);
  };
  const addRoomProductButton = () => {
    setAddRoom(true);
    setEditRoom(false);
    resetForm();
  };
  const deleteClick = (gradeId: number, PrdId: number) => {
    setSelectedAreaGradeId(gradeId);
    setProductId(PrdId);
    setVisibleConfirm(true);
  };
  const resetForm = () => {
    setPrdName('');
    setHour(undefined);
    setPrdBasePrice('');
    setPrdOrgPrice('');
    setAreaGradeIdList([]);
    setProductId(undefined);
    setHourSelectDefalut({
      key: -1,
      value: '0',
      name: `연장시간을 선택해주세요`,
      label: `연장시간을 선택해주세요`,
    });
    setApplyDay([]);
    setExtendType([]);
    setExposureType([]);
    console.log('reset form');
  };

  const confirmDelete = () => {
    if (selectedAreaGradeId !== null && productId !== undefined) {
      delCheckOut(selectedAreaGradeId, productId);
    }
    setVisibleConfirm(false);
  };

  const getApplyDayLabel = (prdData: RoomListCostType) => {
    let label: string[] = [];
    if ([1, 2, 3, 4, 5].every((item) => prdData.apply_day.includes(item))) {
      label.push('평일');
    } else {
      if (prdData.apply_day.includes(1)) {
        label.push('월');
      }
      if (prdData.apply_day.includes(2)) {
        label.push('화');
      }
      if (prdData.apply_day.includes(3)) {
        label.push('수');
      }
      if (prdData.apply_day.includes(4)) {
        label.push('목');
      }
      if (prdData.apply_day.includes(5)) {
        label.push('금');
      }
    }
    if ([0, 6].every((item) => prdData.apply_day.includes(item))) {
      label.push('주말');
    } else {
      if (prdData.apply_day.includes(6)) {
        label.push('토');
      }
      if (prdData.apply_day.includes(0)) {
        label.push('일');
      }
    }
    if (prdData.apply_day.includes(7)) {
      label.push('공휴일');
    }
    return label.join('•');
  };

  const getExtendTypeLabel = (prdData: RoomListCostType) => {
    let label: string[] = [];

    if (prdData.extend_type.includes(0)) {
      label.push('퇴실');
    }
    if (prdData.extend_type.includes(1)) {
      label.push('대실');
    }
    if (prdData.extend_type.includes(2)) {
      label.push('숙박');
    }
    return label.join('•');
  };

  const RoomList = () => {
    return (
      <>
        {roomList && roomList.length > 0 ? (
          roomList.map((data, index) => (
            <div key={index} className="roomListBoxWrap">
              <div className="roomListBox">
                <div className="header">
                  <div className="flex">
                    <div className="numberBox">
                      <p>{index + 1}</p>
                    </div>
                    <h2>{data.area_grade_name}</h2>
                  </div>
                  <p className="roomCount">{data.count} 객실</p>
                </div>
                {data.cost_list.length > 0 ? (
                  <div>
                    {data.cost_list.map((prdData, index) => (
                      <div className="costListWrap" key={index}>
                        <div className="flexWrap">
                          <div className="nameWrap">
                            <div className="numberBox">
                              <p>{index + 1}</p>
                            </div>
                            <p className="prdName">{prdData.name}</p>
                          </div>
                          <div className="flex">
                            <button onClick={() => editRoomButton(prdData)}>
                              <img
                                src={`${process.env.PUBLIC_URL}/svg/ic_edit.svg`}
                                alt="수정아이콘"
                              />
                            </button>
                            <button
                              onClick={() =>
                                deleteClick(prdData.area_grade_id, prdData.product_id)
                              }>
                              <img
                                src={`${process.env.PUBLIC_URL}/svg/ic_delete.svg`}
                                alt="삭제아이콘"
                              />
                            </button>
                          </div>
                        </div>
                        <div className="flexWrap info">
                          <div className="prdHour">
                            <p>{getApplyDayLabel(prdData)}</p> <p>{getExtendTypeLabel(prdData)}</p>
                          </div>
                          <div className="prdPrice">
                            <p>{prdData.hour_extension}시간</p>
                            <p>{prdData.base_price.toLocaleString()}원</p>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                ) : (
                  <div className="noneList">
                    <h2>등록된 상품이 없습니다.</h2>
                  </div>
                )}
              </div>
            </div>
          ))
        ) : (
          <>
            <div className="roomListBox noneList">
              <h2>등록된 객실이 없습니다.</h2>
            </div>
            <Link to={'/setting/roomType'} className="addRoomProduct">
              <img src={`${process.env.PUBLIC_URL}/svg/ic_plus.svg`} alt="추가아이콘" />
              <p>객실 그레이드 설정하기</p>
            </Link>
          </>
        )}
      </>
    );
  };

  const getRoomType = async () => {
    try {
      const oParams = {
        store_id: currentStore.value,
      };
      const oRes: any = await HotelController.getRoomType(oParams);

      if (oRes && oRes.data) {
        const oResponse: any = oRes.data.data;
        setRoomList(oResponse);
      }
    } catch (err) {
      console.log('err-->', err);
    }
  };
  const setCheckOut = async () => {
    if (prdName === '') {
      showToast('상품명을 입력해주세요.', 'error');
    } else if (hour === undefined) {
      showToast('연장시간을 선택해주세요.', 'error');
    } else if (prdBasePrice === undefined || prdBasePrice === '') {
      showToast('판매금액을 입력해주세요.', 'error');
    } else if (!editRoom && areaGradeIdList.length === 0) {
      showToast('객실을 선택해주세요.', 'error');
    } else {
      try {
        const orgPrice =
          prdOrgPrice === undefined || prdOrgPrice === '' ? prdBasePrice : prdOrgPrice;
        const params = {
          store_id: currentStore.value,
          area_grade_id_list: areaGradeIdList,
          hour_extension: hour.value,
          base_price: prdBasePrice,
          org_price: orgPrice,
          name: prdName,
          product_id: productId,
          apply_day: applyDay,
          extend_type: extendType,
          exposure_type: exposureType,
        };
        const response = editRoom
          ? await HotelController.editCheckOut(params)
          : await HotelController.setCheckOut(params);
        if (response && response.data.ok) {
          const toastMsg = editRoom
            ? '객실판매상품이 수정되었습니다.'
            : '객실판매상품이 추가되었습니다.';
          showToast(toastMsg);
          setAddRoom(false);
          setEditRoom(false);
          getRoomType();
          resetForm();
        } else {
          showToast('다시 시도해주세요.', 'error');
        }
      } catch (err) {
        console.log('err-->', err);
      }
    }
  };
  const delCheckOut = async (gradeId: number, prdId: number) => {
    try {
      const oParams = {
        area_grade_id: gradeId,
        product_id: prdId,
      };
      const oRes: any = await HotelController.delCheckOut(oParams);

      if (oRes && oRes.data.ok) {
        showToast('삭제되었습니다.');
        getRoomType();
        setEditRoom(false);
      }
    } catch (err) {
      console.log('err-->', err);
    }
  };

  useEffect(() => {
    getRoomType();
  }, []);

  return (
    <Style>
      {/* 객실 설정 */}
      <HotelRoomSetting />
      {/* 객실 추가 & 수정 */}
      {/* {(addRoom || editRoom) && ( */}
      <div className="contentContainer">
        <div className="inputText">
          <div className="title">
            <h4>상품명</h4>
            <h5>(필수)</h5>
          </div>
          <input
            type="text"
            placeholder="상품명을 입력해주세요  예) 늦은 오후 퇴실하기"
            value={prdName}
            onChange={onChangePrdName}
          />
        </div>
        <div className="inputText">
          <div className="title">
            <h4>연장시간별 금액</h4>
            <h5>(필수)</h5>
          </div>
          <div className="inputWrap">
            <DropdownSelect
              options={hourList}
              defaultValue={hourSelectDefalut}
              onChangeValue={(e: any) => onChangeHour(e)}
            />
            <p>시간 추가 시</p>
            <input
              type="number"
              placeholder="판매금액을 입력해주세요"
              value={prdBasePrice}
              onChange={(e: any) => onChangePrdBasePrice(e)}
            />
            <p>원 입니다.</p>
          </div>
        </div>
        <div className="inputText">
          <div className="title">
            <h4>할인가 표시</h4>
          </div>
          <div className="inputWrap">
            <h3>정가</h3>
            <input type="number" value={prdOrgPrice} onChange={onChangePrdOrgPrice} />
            <h3>를 입력하시면 할인률이 표시됩니다.</h3>
          </div>
        </div>
        {!editRoom && (
          <div className="inputText">
            <div className="title">
              <h4>해당 객실 그레이드</h4>
            </div>
            {roomList.map((data, index) => (
              <div className="gradeNameList">
                <input
                  type="checkbox"
                  className="gradeName"
                  id={`gradeName${index}`}
                  onChange={(e) => handleCheckboxChange(e, index)}
                />
                <label htmlFor={`gradeName${index}`}>
                  <p>{data.area_grade_name}</p>
                </label>
              </div>
            ))}
          </div>
        )}
        <div className="inputText">
          <div className="title">
            <h4>요일 / 공휴일 선택</h4>
          </div>
          {dayGroupList.map((data, index) => (
            <div className="gradeNameList">
              <input
                type="checkbox"
                className="gradeName"
                id={`week${index}`}
                onChange={(e) => handleCheckboxDayGroupChange(e, data.value)}
                checked={getCheckGroupChecked(data.value)}
              />
              <label htmlFor={`week${index}`}>
                <p>{data.name}</p>
              </label>
            </div>
          ))}
          <br />
          <br />
          {dayList.map((data, index) => (
            <div className="gradeNameList">
              <input
                type="checkbox"
                className="gradeName"
                id={`week${index}`}
                onChange={(e) => handleCheckboxStatusChange('applyDay', e, data.value)}
                checked={checkBoxChecked('applyDay', data.value)}
              />
              <label htmlFor={`week${index}`}>
                <p>{data.name}</p>
              </label>
            </div>
          ))}
        </div>
        <div className="inputText">
          <div className="title">
            <h4>대실 / 숙박</h4>
          </div>
          {extendTypeList.map((data, index) => (
            <div className="gradeNameList">
              <input
                type="checkbox"
                className="gradeName"
                id={`extendType${index}`}
                onChange={(e) => handleCheckboxStatusChange('extendType', e, data.value)}
                checked={checkBoxChecked('extendType', data.value)}
              />
              <label htmlFor={`extendType${index}`}>
                <p>{data.name}</p>
              </label>
            </div>
          ))}
        </div>
        <div className="inputText">
          <div className="title">
            <h4>상품 노출</h4>
          </div>
          {exposureTypeList.map((data, index) => (
            <div className="gradeNameList">
              <input
                type="checkbox"
                className="gradeName"
                id={`exposureType${index}`}
                onChange={(e) => handleCheckboxStatusChange('exposureType', e, data.value)}
                checked={checkBoxChecked('exposureType', data.value)}
              />
              <label htmlFor={`exposureType${index}`}>
                <p>{data.name}</p>
              </label>
            </div>
          ))}
        </div>
        <button onClick={setCheckOut} className="submitButton">
          객실 판매 저장하기
        </button>
        <button onClick={setCheckOut} className="submitButton cancel">
          취소
        </button>
      </div>
      {/* )} */}
      <div className={'contentContainer'}>
        <RoomList />
        {roomList && roomList.length > 0 && (
          <button className="addRoomProduct" onClick={addRoomProductButton}>
            <img src={`${process.env.PUBLIC_URL}/svg/ic_plus.svg`} alt="추가아이콘" />
            <p>상품 추가하기</p>
          </button>
        )}
      </div>

      <ConfirmModal
        isOpen={visibleConfirm}
        title={`삭제 후 복구할 수 없습니다.\n정말 삭제하시겠어요?`}
        onCancelText="취소"
        onConfirmText="삭제"
        onCancel={() => setVisibleConfirm(false)}
        onConfirm={confirmDelete}
      />
    </Style>
  );
};

export default HotelRoomSale;

const Style = styled.div`
  .contentContainer:nth-child(1) {
    border-radius: 10px 10px 0 0;
  }
  .contentContainer:nth-child(2) {
    border-radius: 0;
  }
  .contentContainer:nth-child(3) {
    border-radius: 0 0 10px 10px;
  }
  h2 {
    font-size: 18px;
    font-weight: 600;
    color: #555;
  }
  h3 {
    font-size: 14px;
    font-weight: 500;
    color: #555;
  }
  p {
    font-size: 14px;
    font-weight: 500;
    color: #979797;
  }
  input {
    width: 100%;
    padding: 8px 22px;
    border: 1px solid #cecece;
    border-radius: 5px;
  }
  input::placeholder {
    color: #cecece;
  }
  .inputText {
    margin-bottom: 30px;
  }

  /* title */
  .title {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
    gap: 4px;
    color: #555;

    h5 {
      font-size: 14px;
      font-weight: 500;
      color: #40977f;
    }
  }

  /* addRoomProduct */
  .addRoomProduct {
    width: 100%;
    margin-top: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 7px;
    padding: 10px;
    border: 1px solid #4dd2ae;
    border-radius: 5px;

    p {
      font-size: 16px;
      font-weight: 600;
      line-height: 22px;
      color: #4dd2ae;
    }
  }

  /* roomListBox */
  .roomListBox {
    margin-top: 22px;
    border: 1px solid #cecece;
    border-radius: 5px;

    .header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 12px 27px;
      background: #ecf5f3;
      border-bottom: 1px solid #cecece;
      border-top-right-radius: 5px;
      border-top-left-radius: 5px;

      h2 {
        max-width: 350px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
  }
  .numberBox {
    min-width: 26px;
    min-height: 26px;
    margin-right: 14px;
    padding: 2px 7px;
    border: 1px solid #4dd2ae;
    border-radius: 3px;

    p {
      text-align: center;
      color: #40977f;
    }
  }
  .flex {
    display: flex;
    align-items: center;
  }
  .inputWrap {
    display: inline-flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 10px;

    .selector,
    input {
      flex: 1;
      min-width: 180px;
      max-width: 200px;
      font-size: 14px;
      color: #979797;
    }
    input {
      margin-top: 0;
      padding: 8px 10px;
    }
  }
  .gradeNameList {
    display: inline-flex;
    gap: 10px;

    input {
      width: 20px;
      cursor: pointer;
      accent-color: #40977f;
    }
    p {
      margin-right: 26px;
      font-size: 16px;
      font-weight: 400;
      color: #979797;
    }
  }
  .costListWrap {
    padding: 19px 27px;
    display: flex;
    flex-direction: column;
    gap: 8px;

    .flexWrap {
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
    .flexWrap.info {
      margin-left: 40px;
    }

    .nameWrap {
      display: flex;
      align-items: center;
      flex: 1;
    }

    .prdHour,
    .prdPrice {
      text-align: left;
      display: flex;
      p {
        font-size: 14px;
        font-weight: 400;
        color: #979797;
      }
    }
    .prdName {
      flex: 1;
      font-size: 18px;
      font-weight: 400;
      color: #555555;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .prdHour {
      flex: 3;
      p {
        width: 150px;
      }
    }
    .prdPrice {
      flex: 2;
      gap: 30px;
    }

    button {
      padding: 0 8px;
      img {
        width: 24px;
        height: 24px;
      }
    }
  }

  .noneList {
    padding: 30px 0;
    text-align: center;

    h2 {
      color: #cecece;
      font-weight: 400;
    }
  }

  .submitButton {
    width: 100%;
    text-align: center;
  }
  .submitButton.cancel {
    margin-top: 20px;
    padding: 11px 0;
    background: #fff;
    border: 1px solid #4dd2ae;
    color: #4dd2ae;
  }

  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  input[type='number'] {
    -moz-appearance: textfield;
  }

  @media (max-width: 600px) {
    h3 {
      font-size: 12px;
    }
    .inputWrap {
      margin-top: 0;
      gap: 5px;

      input {
        min-width: 100px;
      }
    }

    .costListWrap {
      padding: 14px 20px;
      gap: 6px;

      .prdHour,
      .prdPrice {
        flex-direction: column;
        p {
          font-size: 12px;
        }
      }
      .prdName {
        font-size: 16px;
      }
      .prdHour {
        flex: 2;
        p {
          width: auto;
        }
      }
      .prdPrice {
        flex: 1;
        gap: 0;
      }

      button {
        padding: 0 8px;
        img {
          width: 20px;
          height: 20px;
        }
      }
    }
  }
`;
